import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n } from 'arm-common';

const EnumFondiAction = Object.freeze({
    FONDI_LIST: 'FONDI_LIST',
    FONDO_DETAILS: 'FONDO_DETAILS',
    FONDI_INITIALIZED: 'FONDI_INITIALIZED',
    FONDO_DELETE: 'FONDO_DELETE',
    FONDI_UPDATE: 'FONDI_UPDATE',
    FONDI_HANDLE_CHANGE: 'FONDI_HANDLE_CHANGE',
    LISTA_PRODOTTI_PER_FONDO: 'LISTA_PRODOTTI_PER_FONDO',
    LINEA_DETAILS: 'LINEA_DETAILS'
});

module.exports.EnumFondiAction = EnumFondiAction;

class FondiAction extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[FondiAction] ";
    }
    get Actions() {

        return EnumFondiAction;
    }

    clearAll() {
        return function (dispatch) {
            dispatch({ type: EnumFondiAction.FONDI_INITIALIZED });
        }
    }

    getListaFondi() {
        console.log(" in fondiAction listaFondi")
        return function (dispatch) {
            return Rest.post('admin/fondo/listaFondi', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFondiAction.FONDI_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });

        }
    }

    listaStrumentoCompagnie(codStrum) {
        return function (dispatch) {
            return Rest.postForm('admin/fondo/listaStrumentoCompagnie', { codStrum: codStrum }, dispatch).then(
                resolve => {

                    let fondi = {
                        detailsFondi: {
                            listStumentiCompagnia: {
                                $set: resolve
                            }
                        }
                    }

                    dispatch({
                        type: EnumFondiAction.FONDI_UPDATE,
                        fondi: fondi
                    });
                }, reject => {
                    return reject;
                });

        }
    }


    
    listaProdottiFondi(idFondo) {
        return function (dispatch) {
            return Rest.postForm('admin/fondo/listaProdottiFondi', { idFondo: idFondo }, dispatch).then(                
                resolve => {

                    let fondi = {
                        listaProdottiPerFondo: {
                                $set: resolve
                        }
                    }

                    dispatch({
                        type: EnumFondiAction.FONDI_UPDATE,
                        fondi: fondi
                    });
                }, reject => {
                    return reject;
                });

        }
    }


    inputChangeHandlerProdotti(name, value) {
        console.log(this.moduleName + " inputChangeHandlerProdotti: ");
        return (dispatch, getState) => {

            if (value === "") {
                value = null;
            }

            let prodotto = {
                fondo: {
                    [name]: {
                        $set: value
                    }

                },
            }
            dispatch({
                type: EnumFondiAction.FONDI_UPDATE,
                prodotto: prodotto
            });
            return Promise.resolve();
        }
    }


    salvaFondi(modifica) {
        return function (dispatch, getState) {
            let fondiToSave = new Object();
            fondiToSave = getState().fondi.detailsFondi;

            if (modifica) {

                return Rest.post("admin/fondo/updateFondo", fondiToSave, dispatch).then(
                    function (resolve) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_AGGIORNATO_CON_SUCCESSO', 'Fondo modificato con successo')));
                        return resolve;
                    },
                    function (reject) {
                        return reject;
                    });

            } else {
                return Rest.post("admin/fondo/salvaFondo", fondiToSave, dispatch).then(
                    function (resolve) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_INSERITA_CON_SUCCESSO', 'Fondo inserito con successo')));
                        return resolve;
                    },
                    function (reject) {
                        return reject;
                    });
            }
        }
    }

    inizializzaNuovaCompagnia() {
        return function (dispatch, getState) {

            let fondi = {
                compagnia: {
                    $set: {}
                }
            }

            dispatch({
                type: EnumFondiAction.FONDI_UPDATE,
                fondi: fondi
            });
        }
    }

    salvaCompagniaStrumento() {
        return function (dispatch, getState) {

            let compagnia = getState().fondi.compagnia;
            let fondo = getState().fondi.detailsFondi;
            compagnia.codStrum = fondo.fonId;

            return Rest.post("admin/fondo/salvaStrumentoCompagnia", compagnia, dispatch).then(
                function (resolve) {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_COMP_INSERITA_CON_SUCCESSO', 'Compagnia strumento inserita con successo')));
                    return resolve;
                },
                function (reject) {
                    return reject;
                });
        }
    }


    salvaProdottoLineaLiberaFondi() {
        return function (dispatch, getState) {

            let fondo = getState().prodotto.fondo;
            let listLienaLibera = getState().prodotto.listaProdottiLineaLibera;
            
            return Rest.post("admin/fondo/salvaProdottiFondi", fondo, dispatch).then(
                function (resolve) {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_COMP_INSERITA_CON_SUCCESSO', 'Prodotto con fondo inserita con successo')));
                    return resolve;
                },
                function (reject) {
                    return reject;
                });
        }
    }

    handleChangeCompagniaStrum(id, value) {
        return function (dispatch, getState) {
            let fondi = {
                compagnia: {
                    [id]: {
                        $set: value
                    }
                }
            }

            dispatch({
                type: EnumFondiAction.FONDI_UPDATE,
                fondi: fondi
            });
            return Promise.resolve();
        }
    }

    /* salvaFondi(history) {
         return function (dispatch, getState) {
             let fondiToSave = new Object();
             fondiToSave = getState().fondi.detailsFondi;
             return Rest.post("admin/fondo/salvaFondo", fondiToSave, dispatch).then(
                 function (resolve) {
                     dispatch({ type: EnumFondiAction.FONDO_DETAILS, dati: resolve });
                     if (fondiToSave.fonId === null || fondiToSave.fonId === undefined) {
                         dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_INSERITA_CON_SUCCESSO', 'Fondo inserito con successo')));
                     } else {
                         dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_MODIFICATA_CON_SUCCESSO', 'Fondo modificato con successo')));
                     }
                     history.push({ pathname: '/fondi/details', state: { fonId: resolve.fonId } })
                     return resolve;
                 },
                 function (reject) {
                     dispatch(AppActions.addNotify('WARNING', i18n('ARM_CORE_PRODUCT.FONDI.NON_SI_PUO_INSERIRE_FONDI', 'Non si puo inserire il fondo')));
                     return reject;
                 });
         }
     }*/
    getFondoDetails(fonId) {
        return function (dispatch) {
            return Rest.postForm('admin/fondo/getFondoById', { fonId: fonId }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFondiAction.FONDO_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    deleteFondo(fonId) {
        return function (dispatch) {
            return Rest.postForm('admin/fondo/eliminaFondo', { fonId: fonId }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFondiAction.FONDO_DELETE, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_ELIMINATO_CON_SUCCESSO', 'Fondo eliminato con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    handleChange(id, value) {
        return function (dispatch) {
            let object = {};
            object[id] = value;
            dispatch({
                type: EnumFondiAction.FONDI_HANDLE_CHANGE,
                dato: object
            });

            return Promise.resolve();
        }
    }

    deleteStrumentoCmp(id) {
        return function (dispatch, getState) {
            return Rest.postForm('admin/fondo/eliminaStrumentoCmp', { id: id }, dispatch).then(
                resolve => {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.COMPAGNIA.CMP_ELIMINATA_CON_SUCCESSO', 'Compagnia eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    getListProdottoFondi(idFondo) {
        return function (dispatch) {
            return Rest.postForm('admin/fondo/listaProdottiFondi', { idFondo: idFondo }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFondiAction.LISTA_PRODOTTI_PER_FONDO, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }


    getLinea(id) {
        return function (dispatch) {
            return Rest.postForm('admin/fondo/getLinea', { id: id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFondiAction.LINEA_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }
    
   
    inizializzaModificaCompagnia(row) {
        return function (dispatch, getState) {

            let fondi = {
                compagnia: {
                    $set: row
                }
            }

            dispatch({
                type: EnumFondiAction.FONDI_UPDATE,
                fondi: fondi
            });
            return Promise.resolve();
        }
    }

    inputChangeHandlerCompagnia(name, value) {

        console.log(this.moduleName + " inputChangeHandlerCompagnia: ");
        return (dispatch, getState) => {

            if (value === "") {
                value = null;
            }

            let fondi = {
                compagnia: {
                    [name]: {
                        $set: value
                    }
                

                },
            }
            dispatch({
                type: EnumFondiAction.FONDI_UPDATE,
                fondi: fondi
            });
            return Promise.resolve();
        }
    }


    salvaCompagniaModifica(){
        return function (dispatch, getState) {

            let compagnia = getState().fondi.compagnia;
            let fondo = getState().fondi.detailsFondi;
            compagnia.codStrum = fondo.fonId;

            return Rest.post("admin/fondo/salvaStrumentoCompagniaModifica", compagnia, dispatch).then(
                function (resolve) {
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FONDI.FONDO_COMP_INSERITA_CON_SUCCESSO', 'Compagnia strumento modifcato con successo')));
                    return resolve;
                },
                function (reject) {
                    return reject;
                });
        }
    }


}
export default FondiAction = new FondiAction;